const notifications = [
    {
        "id": 1,
        "read": false,
        "title": "LPO",
        "time": "a few moments ago",
        "link": "#",
        "number": `98.9`
    },
        {
        "id": 2,
        "read": false,
        "title": "ERQ",
        "time": "a few moments ago",
        "link": "#",
        "number": `98.9`
    },
        {
        "id": 3,
        "read": false,
        "title": "IPH",
        "time": "a few moments ago",
        "link": "#",
        "number": `98.9`
    },
]

export default notifications; 